module.exports = __webpack_public_path__ + "static/media/ISCI_SSC1.4d47a539.jpg";